<template>
  <div class="">
    <p class="top-header">
      Trucks
      <v-btn
        @click="initialize()"
        small
        class="text-capitalize float-right"
        color="primary"
        dark
        ><v-icon class="mr-2" small>mdi-refresh</v-icon
        >{{ $t("Reload") }}</v-btn
      >
    </p>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <hr class="mb-3" />
    <div class="d-flex flex-row align-center justify-space-between mb-5">
    <v-btn
      small
      width="200"
      class="text-capitalize mb-2"
      color="primary"
      @click="goToCreate()"
      >+ Create Truck</v-btn
    >
      <div class="d-flex flex-row align-center">
        <v-text-field
          @keydown.enter="initialize()"
          v-model="qSearch"
          solo
          dense
          flat
          label="Search Trucks ..."
          style="max-width: 250px; border-radius: 8px"
          hide-details
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="trucks"
      :options.sync="options"
      :server-items-length="totalTrucks"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon class="cursor--pointer" @click="goToTruck(item)">
          mdi-pencil
        </v-icon>
        <v-icon class="cursor--pointer" @click="openUploadFiles(item)">
          mdi-camera
        </v-icon>
        <v-icon class="cursor--pointer" @click="downloadBarCode(item)">
          mdi-barcode
        </v-icon>
        <v-icon
          class="cursor--pointer red--text ml-1"
          @click="setTruckToRemove(item._id)"
        >
          mdi-trash-can
        </v-icon>
      </template>
      <!--      <template v-slot:[`item.models`]="{ item }">-->
      <!--        <v-icon class="cursor&#45;&#45;pointer" @click="goToModels(item.name)">-->
      <!--          mdi-share-->
      <!--        </v-icon>-->
      <!--      </template>-->
      <template v-slot:[`item.model`]="{ item }">
        {{
          item.model[0] !== undefined && item.model[0].hasOwnProperty("brand")
            ? item.model[0].brand.name
            : "-"
        }}
        {{
          item.model[0] !== undefined && item.model[0].hasOwnProperty("name")
            ? item.model[0].name
            : ""
        }}
      </template>
      <template v-slot:[`item.engine`]="{ item }">
        {{
          item.engineModel[0] !== undefined &&
          item.engineModel[0].hasOwnProperty("manufacturer")
            ? item.engineModel[0].manufacturer.name
            : "-"
        }}
        {{
          item.engineModel[0] !== undefined &&
          item.engineModel[0].hasOwnProperty("name")
            ? item.engineModel[0].name
            : ""
        }}
      </template>
      <template v-slot:[`item.pictureUrls`]="{ item }">
        <div
          class="d-flex flex-column align-start dnd-container"
          v-if="item.pictureUrls.length > 0"
        >
          <Container
            v-if="item.pictureUrls.length > 0"
            class="d-flex align-center"
            orientation="horizontal"
            behaviour="contain"
            drag-class="opacity-ghost"
            drop-class="opacity-ghost-drop"
            :drop-placeholder="dropPlaceholderOptions"
            @drop="
              e =>
                onImageDrop(
                  {
                    productIndex: productPos(item._id),
                    productId: item._id
                  },
                  e
                )
            "
            :remove-on-drop-out="true"
          >
            <Draggable
              v-for="(pictureItem, index) in trucks[productPos(item._id)]
                .pictureUrls"
              :key="index"
            >
              <v-hover v-slot="{ hover }">
                <v-img
                  :src="`${staticUrl}/${item._id}/${pictureItem}`"
                  height="80"
                  max-width="80"
                  contain
                  class="rounded ma-1"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                        size="32"
                      ></v-progress-circular>
                    </v-row>
                  </template>

                  {{/* Remove button */}}
                  <v-slide-y-transition>
                    <v-row
                      v-if="hover"
                      class="remove-button fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-btn
                        color="error"
                        elevation="0"
                        width="30"
                        height="30"
                        fab
                        small
                        tile
                        @click="setImageRemoveFrom(item._id, index)"
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                  </v-slide-y-transition>
                </v-img>
              </v-hover>
            </Draggable>
          </Container>
        </div>
      </template>
    </v-data-table>

    {{/* Upload dialog */}}
    <v-dialog v-model="uploadFileDialog" max-width="500px">
      <v-card class="pa-3">
        <v-card-title>
          <div class="mb-3">
            <span class=""> Upload pictures</span>
          </div>
          <v-spacer></v-spacer>
          <v-icon @click="closeUploadFilesDialog()">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-file-input
                dense
                color="primary"
                v-model="selectedTruck.files"
                placeholder="Select your file(s)"
                outlined
                multiple
              ></v-file-input>
            </v-form>

            {{/* Preview images */}}
            <v-slide-group v-if="uploadedImagePreview" show-arrows>
              <v-slide-item
                v-for="(imagePath, index) in uploadedImagePreview"
                :key="index"
              >
                <v-hover v-slot="{ hover }">
                  <v-img
                    :src="imagePath"
                    height="80"
                    max-width="80"
                    contain
                    class="rounded ma-1"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-linear color="blue" indeterminate rounded />
                      </v-row>
                    </template>

                    {{/* Remove button */}}
                    <v-fade-transition>
                      <v-row
                        v-if="hover"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-btn
                          color="error"
                          elevation="0"
                          fab
                          small
                          @click="() => removeImageToUpload(index)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-row>
                    </v-fade-transition>
                  </v-img>
                </v-hover>
              </v-slide-item>
            </v-slide-group>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            color="red darken-1"
            width="100"
            class="ml-5"
            dark
            @click="closeUploadFilesDialog()"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            width="100"
            class="mr-5"
            :loading="sending"
            color="green darken-1"
            dark
            @click="uploadFiles()"
            >Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    {{/* Confirm image deletion dialog */}}
    <v-dialog
      v-model="dialogRemoveImage"
      max-width="320"
      :disabled="loadingRemoving"
      :persistent="loadingRemoving"
    >
      <v-card>
        <v-card-title class="headline">
          Remove this picture?
        </v-card-title>

        <v-img :src="imageToRemove" width="100%" height="auto">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-linear color="blue" indeterminate rounded />
            </v-row>
          </template>

          {{/* Loading removing */}}
          <v-row
            v-if="loadingRemoving"
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular color="blue" indeterminate rounded />
          </v-row>
        </v-img>

        <v-card-actions class="justify-end">
          <v-btn color="grey" text @click="dialogRemoveImage = false">
            cancel
          </v-btn>

          <v-btn
            color="error"
            :disabled="loadingRemoving"
            depressed
            @click="
              () =>
                removeImage(imageRemoveFrom.productId, imageRemoveFrom.index)
            "
          >
            remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    {{/* Confirm truck deletion */}}
    <v-dialog
      v-model="dialogRemoveTruck"
      max-width="320"
      :disabled="loadingRemovingTruck"
      :persistent="loadingRemovingTruck"
    >
      <v-card>
        <v-card-text class="pt-3">
          <div class="text-body-1">
            Do you want remove the truck?
          </div>
          <v-progress-linear
            v-if="loadingRemovingTruck"
            class="my-2"
            indeterminate
            rounded
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="grey" text @click="dialogRemoveTruck = false">
            cancel
          </v-btn>

          <v-btn
            color="error"
            :disabled="loadingRemovingTruck"
            depressed
            @click="removeTruck"
          >
            remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import RestResourceBrand from "@/api/apiBrandService";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceTruck from "../../api/apiTruckService";
import * as axios from "axios";
// For drag and drop images
import { applyDrag } from "@/views/Truck/dragDropUtils";
import { Container, Draggable } from "vue-smooth-dnd";
import { getAPI } from "@/api/axios-base";

export default {
  components: { Container, Draggable },
  data() {
    return {
      serverUrl: process.env.VUE_APP_BASE_URL,
      staticUrl: process.env.VUE_APP_BASE_STATIC,
      loadingTable: false,
      options: {},
      footerProps: vdataTable.footerProps,
      totalTrucks: 0,
      pagination: {},
      errorAlert: false,
      errorMsg: "",
      selectedTruck: {
        _id: "",
        files: []
      },
      filterParams: {
        code: null
      },
      sending: false,
      uploadFileDialog: false,
      qSearch: null,
      headers: [
        {
          text: this.$t("Edit"),
          width: 150,
          align: "start",
          sortable: false,
          value: "edit"
        },
        {
          text: "Model",
          align: "start",
          width: 250,
          sortable: false,
          value: "model"
        },
        {
          text: "Year",
          align: "start",
          sortable: false,
          value: "year"
        },
        {
          text: "Engine",
          align: "start",
          width: 250,
          sortable: false,
          value: "engine"
        },
        {
          text: "Mileage",
          align: "end",
          sortable: false,
          value: "mileage"
        },
        {
          text: "Vin",
          align: "end",
          sortable: false,
          value: "vin"
        },
        {
          text: "Exterior color",
          align: "end",
          sortable: false,
          value: "exterior_color"
        },
        {
          text: "Interior color",
          align: "end",
          sortable: false,
          value: "interior_color"
        },
        {
          text: "Transmission",
          align: "end",
          sortable: false,
          value: "transmission"
        },
        {
          text: "Wheel base",
          align: "end",
          sortable: false,
          value: "wheelBase"
        },
        {
          text: "Status",
          align: "end",
          sortable: false,
          value: "status"
        },
        {
          text: "Code",
          align: "end",
          sortable: false,
          value: "code"
        },
        {
          text: "Pictures",
          align: "center",
          sortable: false,
          value: "pictureUrls"
        }
      ],
      trucks: [],
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "200",
        showOnTop: true
      },
      // Proceso de borrar imagenes
      dialogRemoveImage: false,
      imageToRemove: "",
      imageRemoveFrom: {
        productId: "",
        index: 0
      },
      loadingRemoving: false,

      // Proceso de borrar camiones
      truckToRemove: "",
      loadingRemovingTruck: false,
      dialogRemoveTruck: false
    };
  },
  computed: {
    uploadedImagePreview() {
      const result = [];

      if (
        this.selectedTruck.files == undefined ||
        this.selectedTruck.files == null
      )
        return;

      this.selectedTruck.files.forEach(file => {
        result.push(URL.createObjectURL(file));
      });

      return result;
    }
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  methods: {
    async initialize() {
      const { page, itemsPerPage } = this.options;
      this.loadingTable = true;
      const params = {
        ...this.filterParams,
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      RestResourceTruck.prototype
        .getTrucks(params)
        .then(resp => {
          this.trucks = resp.data.data;
          this.totalTrucks = resp.data.total;
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToCreate() {
      this.$router.push({ name: "new_truck" });
    },
    goToTruck(truck) {
      this.$router.push({
        name: "truckId",
        params: { id: truck._id }
      });
    },
    async downloadBarCode(truck) {
      this.downloadWithAxios(
        this.serverUrl + "/api/rest/v1/truck/qr/" + truck._id,
        "TRUCK_" + truck.code,
        "pdf"
      );
    },
    downloadWithAxios(url, code, ext) {
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, code, ext);
        })
        .catch(e => {
          console.log("error occured");
          console.log(e.message);
        });
    },
    forceFileDownload(response, code, ext) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", code + "." + ext); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    openUploadFiles(item) {
      this.selectedTruck = Object.assign({}, item);
      this.uploadFileDialog = true;
    },
    closeUploadFilesDialog() {
      setTimeout(() => {
        this.selectedTruck = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.uploadFileDialog = false;
    },
    async uploadFiles() {
      this.sending = true;
      if (!this.$refs.form.validate()) return;
      try {
        let body = { _id: this.selectedTruck._id };
        if (this.selectedTruck.files)
          body = { ...body, files: this.selectedTruck.files };
        await RestResourceTruck.prototype.uploadFiles(body);
        this.closeUploadFilesDialog();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeUploadFilesDialog();
      } finally {
        await this.initialize();
        this.sending = false;
      }
    },
    async getPicture(id, picture) {
      try {
        const log = await RestResourceTruck.prototype.getPicture(id, picture);
        return log.data;
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
      }
    },
    // Drag and drop images to reorder
    onImageDrop(dropPayload, dropResult) {
      // console.log(dropResult);

      // Prevenir que no se arrastre fuera del grupo de imagenes
      const dropData =
        dropResult.addedIndex == null || dropResult.addedIndex == undefined
          ? {
              removedIndex: dropResult.removedIndex,
              addedIndex: dropResult.removedIndex
            }
          : dropResult;
      const currentPictureUrls = this.trucks[dropPayload.productIndex]
        .pictureUrls;
      const reorderedPictureurls = applyDrag(currentPictureUrls, dropData);

      this.trucks[dropPayload.productIndex].pictureUrls = reorderedPictureurls;

      // Send to backend here
      getAPI.put("api/rest/v1/truck/" + dropPayload.productId, {
        pictureUrls: reorderedPictureurls
      });
    },
    productPos(id) {
      let productPos = 0;

      this.trucks.find((trucks, index) => {
        if (trucks._id == id) {
          productPos = index;

          return trucks._id == id;
        }
      });

      return productPos;
    },
    // Remove process
    setImageRemoveFrom(productId, index) {
      const picture = this.trucks[this.productPos(productId)].pictureUrls[
        index
      ];
      this.imageToRemove = `${this.staticUrl}/${productId}/${picture}`;
      this.imageRemoveFrom = { productId: productId, index: index };
      this.dialogRemoveImage = true;
    },
    removeImage(productId, index) {
      const productIndex = this.productPos(productId);

      this.loadingRemoving = true;
      getAPI
        .put("api/rest/v1/truck/" + productId, {
          pictureUrls: this.trucks[productIndex].pictureUrls
        })
        .then(() => {
          this.trucks[productIndex].pictureUrls.splice(index, 1);
          this.loadingRemoving = false;
          this.dialogRemoveImage = false;
        });
    },
    removeImageToUpload(index) {
      this.selectedTruck.files.splice(index, 1);
    },
    setTruckToRemove(productId) {
      this.truckToRemove = productId;
      this.dialogRemoveTruck = true;
    },
    removeTruck() {
      const url = "api/rest/v1/truck/" + this.truckToRemove;

      this.loadingRemovingTruck = true;
      getAPI.delete(url).then(() => {
        this.loadingRemovingTruck = false;
        this.dialogRemoveTruck = false;
        this.initialize();
      });
    }
  }
};
</script>

<style scoped>
.custom-th {
  font-size: 0.6rem;
}
.top-btn-driver {
  width: 30%;
  font-size: 0.73rem;
}

@media (max-width: 520px) {
  .top-btn-box {
    flex-direction: column;
  }
  .top-btn-driver {
    margin-bottom: 0.5rem;
    width: 100%;
    font-size: 0.8rem;
  }
}

.dnd-container {
  max-width: 320px;
  overflow-x: auto;
}

.dnd-container .remove-button {
  position: relative;
}

.dnd-container .remove-button .v-btn {
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 5px !important;
}

/* For drag & drop */
.opacity-ghost {
  transition: transform 0.18s ease, opacity 0.18s ease;
  opacity: 0.8;
  transform: rotateZ(8deg);
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}

.opacity-ghost .v-btn {
  display: none;
}

.opacity-ghost-drop {
  opacity: 1;
  transform: rotateZ(0deg);
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0);
}
</style>
